import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { CommonService } from '../../services/common/common.service';
import { BATTERY_THRESHOLD_SWITCH_ID } from 'src/app/constants/power.constants';

@Component({
	selector: 'material-slide-toggle',
	templateUrl: './material-slide-toggle.component.html',
	styleUrls: ['./material-slide-toggle.component.scss']
})
export class MaterialSlideToggleComponent implements OnInit, OnDestroy {
	public static switchChange: Subject<boolean> = new Subject<boolean>();
	@Output() toggle: EventEmitter<any> = new EventEmitter();
	@Input() value: boolean;
	@Input() id: string;
	@Input() disabled = false;
	@Input() loading = false;
	@Input() readonly = false;
	@Input() tabIndex = 0;
	@Input() isSwitchDisable = false;
	@Input() isSwitchUpdate = false;
	@Input() label: string = "";
	@Input() ariaLabel: string;
	@Input() sendMetrics = true;
	@Input() metricsParent;
	@Input() switchParam: string;

	uiSubscription: Subscription;
	private switchChangeSubscription: Subscription;

	size = 'switch-xs';

	switchOnText = this.tranlateService.instant('common.ui.on');
	switchOffText = this.tranlateService.instant('common.ui.off');

	constructor(
		public commonService: CommonService,
		public tranlateService: TranslateService
	) { }

	ngOnInit() {
		this.readonly = this.readonly || false;
		this.uiSubscription = this.commonService.notification.subscribe((response) => {
			if (response.type === this.id) {
				this.value = response.payload;
			}
		});
		this.switchChangeSubscription = MaterialSlideToggleComponent.switchChange.subscribe({
			next: value => {
				if (this.id === BATTERY_THRESHOLD_SWITCH_ID) {
					this.value = value;
				}
			}
		});
	}

	ngOnDestroy() {
		if (this.uiSubscription) {
			this.uiSubscription.unsubscribe();
		}
		if (this.switchChangeSubscription) {
			this.switchChangeSubscription.unsubscribe();
		}
	}

	/**
	 *
	 * @param $event the toggle button info.
	 * this function is to send the change event for readonly = false types.
	 */
	onChange($event) {
		
		setTimeout(() => {
			if (!this.readonly) {
				this.disabled = true;
				if (this.id === 'recommended-updates') {
					this.disabled = this.isSwitchDisable;
					this.value = !this.value;
				} else if (this.id !== 'sa-ws-switch') {
					this.disabled = false;
					this.value = !this.value;
				}

				$event.switchValue = this.value;
				this.toggle.emit($event);
			}
		}, 0);

	}

	/**
	 *
	 * @param $event the toggle button info.
	 * this function is to send the change event for the readonly = true types.
	 */
	sendChangeEvent($event) {
		if (this.readonly) {
			$event.switchValue = !this.value;
			this.toggle.emit($event);
		}
	}

	stopPropagation(event) {
		event.stopPropagation();
	}
}
